import React, { useEffect, useState } from 'react'

const IbWallet = ({active}) => {
    const [primaryColor, setPrimaryColor] = useState(active ? "#fff" : (getComputedStyle(document.documentElement).getPropertyValue('--theme'))?.trim())
    useEffect(() => {
      setPrimaryColor(active ? "#fff" : (getComputedStyle(document.documentElement).getPropertyValue('--theme'))?.trim())
      
    }, [active])
    return (
        <svg width="24" height="24" viewBox="0 0 28 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M17 2H11C6.75736 2 4.63604 2 3.31802 3.31802C2 4.63604 2 6.75736 2 11V14C2 18.2426 2 20.364 3.31802 21.682C4.63604 23 6.75736 23 11 23H17C21.2426 23 23.364 23 24.682 21.682C26 20.364 26 18.2426 26 14V11C26 6.75736 26 4.63604 24.682 3.31802C23.364 2 21.2426 2 17 2Z" stroke={primaryColor} stroke-width="2.5" />
            <path d="M7.33325 7.25H11.3333" stroke={primaryColor} stroke-width="2.5" stroke-linecap="round" />
            <path d="M18 15.75V14.5C18 13.5572 18 13.0858 18.2929 12.7929C18.5858 12.5 19.0572 12.5 20 12.5H24C24.9428 12.5 25.4142 12.5 25.7071 12.7929C26 13.0858 26 13.5572 26 14.5V15.75C26 16.6928 26 17.1642 25.7071 17.4571C25.4142 17.75 24.9428 17.75 24 17.75H20C19.0572 17.75 18.5858 17.75 18.2929 17.4571C18 17.1642 18 16.6928 18 15.75Z" stroke={primaryColor} stroke-width="2.5" />
        </svg>

    )
}

export default IbWallet